import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-640fb13c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "image-upload" };
const _hoisted_2 = ["src"];
import { ref, computed } from 'vue';
import { useCalendarImagesStore } from '../stores/calendarImages';
import { useRouter } from 'vue-router';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ImageUpload',
    props: {
        imageIndex: null
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        const calendarImagesStore = useCalendarImagesStore();
        const fileInput = ref(null);
        const sourceFile = computed(() => {
            if (calendarImagesStore.calendarImages[props.imageIndex] === undefined) {
                return 'upload-image.png';
            }
            else {
                if (calendarImagesStore.calendarImages[props.imageIndex].cropper.cropped === null) {
                    return 'upload-image.png';
                }
                else {
                    return calendarImagesStore.calendarImages[props.imageIndex].cropper.cropped?.toDataURL();
                }
            }
        });
        function onFileSelected(e) {
            const fileInputElement = e.target;
            if (fileInputElement.files) {
                if (calendarImagesStore.calendarImages[props.imageIndex] === undefined) {
                    calendarImagesStore.calendarImages.push({
                        imageFile: fileInputElement.files[0],
                        cropper: {
                            scaledX: 1,
                            scaledY: 1,
                            cropped: null,
                        }
                    });
                }
                else {
                    calendarImagesStore.calendarImages[props.imageIndex].imageFile = fileInputElement.files[0];
                }
                router.push('/photo/' + props.imageIndex);
            }
        }
        function imageClick() {
            if (calendarImagesStore.calendarImages[props.imageIndex] === undefined) {
                fileInput.value?.click();
            }
            else {
                router.push('/photo/' + props.imageIndex);
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("img", {
                    class: "preview",
                    src: _unref(sourceFile),
                    onClick: imageClick
                }, null, 8, _hoisted_2),
                _createElementVNode("input", {
                    class: "d-none",
                    ref_key: "fileInput",
                    ref: fileInput,
                    accept: "image/*",
                    type: "file",
                    onChange: _cache[0] || (_cache[0] = ($event) => (onFileSelected($event)))
                }, null, 544)
            ]));
        };
    }
});
